import { Button } from '@askable/ui/core/button';
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogOverlay } from '@askable/ui/core/dialog';
import { useTranslation } from 'react-i18next';

import type { FC } from 'react';

type Props = {
  open: boolean;
  onClose: () => void;
};

export const DeviceSafariPermissionDeniedAndPromptedDialog: FC<Props> = ({ open, onClose }) => {
  const { t } = useTranslation();

  return (
    <Dialog
      open={open}
      onOpenChange={isOpen => {
        if (!isOpen) {
          onClose();
        }
      }}
    >
      <DialogOverlay>
        <DialogContent>
          <DialogHeader>{t('errors.allowAccess')}</DialogHeader>
          <div className="flex flex-col gap-4">
            {t('errors.devicePermission')} {t('permissions.media.descriptionLine2')}
            <ol className="flex list-disc flex-col gap-2 pl-6">
              <li>{t('permissions.media.instructionsLine1')}</li>
              <li>{t('permissions.media.instructionsLine2')}</li>
              <li>{t('permissions.media.instructionsLine3')}</li>
              <li>{t('permissions.media.instructionsLine4')}</li>
            </ol>
          </div>

          <DialogFooter>
            <Button onClick={onClose}>{t('global.dismiss')}</Button>
          </DialogFooter>
        </DialogContent>
      </DialogOverlay>
    </Dialog>
  );
};
